/**
 * Tab definitions.
 * `key` maps directly to content?.components?.discount_management?.tabs?.[key]
 */
export const TABS = [
  { key: 'all' },
  { key: 'activated' },
  { key: 'deactivated' },
  { key: 'used' },
  { key: 'expired' }
];

export const COLUMNS = [
  { key: 'coupon_code' },
  { key: 'description' },
  { key: 'product_name' },
  { key: 'start_date' },
  { key: 'end_date' },
  { key: 'status' },
  { key: 'order_id' },
  { key: 'actions' }
];
